export const getDefaultDateTime = () =>
  new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 16);

export const dateStr = new Date().toISOString().split('T')[0];

const decodeHtmlEntities = (text: string): string => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

export const getErrorMessage = (error: any) => {
  const status = error?.status ?? error?.response?.status;
  const errorData = error?.data ?? error?.response?.data ?? null;
  const message = error?.message ?? errorData?.message ?? error?.response?.statusText ?? null;

  if (status === 409 && errorData?.validation_errors) {
    let errorMessage = errorData.message ? decodeHtmlEntities(errorData.message) : 'Знайдено дублікати записів';

    // Group by station for cleaner display
    const stationGroups = errorData.validation_errors.reduce((groups: any, err: any) => {
      if (!groups[err.station_code]) groups[err.station_code] = [];
      groups[err.station_code].push(err);
      return groups;
    }, {});

    const validationDetails = Object.keys(stationGroups)
      .map(stationCode => {
        const stationErrors = stationGroups[stationCode];
        const fuelTypes = stationErrors.map((err: any) => `${err.fuel_type} (ціна ${err.price})`).join(', ');
        const dateTime = new Date(stationErrors[0].date_time).toLocaleString('uk-UA');
        return `<strong>Станція ${stationCode}</strong><br>${fuelTypes}<br>Дата: ${dateTime}`;
      })
      .join('<br><br>');

    errorMessage += `<br><br>${validationDetails}`;
    return errorMessage;
  } else if (status === 400 && errorData?.errors) {
    // Validation errors - show detailed error list line by line
    let errorMessage = errorData.message ? decodeHtmlEntities(errorData.message) : 'Помилка валідації файлу';

    if (errorData.errors && Array.isArray(errorData.errors)) {
      const errorLines = errorData.errors
        .map((err: string, index: number) => `${index + 1}. ${decodeHtmlEntities(err)}`)
        .join('<br>');
      errorMessage += `<br><br>${errorLines}`;
    }

    return errorMessage;
  } else if (status === 413) {
    // File too large
    return 'Файл занадто великий для завантаження';
  } else if (status === 415) {
    // Unsupported file type
    return 'Непідтримуваний формат файлу. Використовуйте Excel файли (.xlsx)';
  } else if (status >= 500) {
    // Server error
    return 'Помилка сервера. Спробуйте пізніше або зверніться до підтримки';
  } else if (status === 401) {
    // Authentication error
    return 'Помилка автентифікації. Будь ласка, оновіть сторінку';
  } else {
    // Generic error
    const errorMessage = message ? decodeHtmlEntities(message) : 'Помилка завантаження файлу';
    return errorMessage;
  }
};

export const defaultSends = { sendSMS: false, sendMail: false, send1C: false, sendOkkoCore: false };
